export type ListCodeType = {
  code: number
  message?: string
}

export const listCode: ListCodeType[] = [{ code: 1007 }]
